import React from "react";

/**
 * Reusable XP-style panel with a colored title bar.
 * variant: "blue" | "green" | "lemon" | "red"
 */
export default function Panel({ title, icon: Icon, variant = "blue", children, actions, className = "", contentClassName = "", "data-testid": testId }) {
  const bar = {
    blue: "xp-titlebar-blue",
    green: "xp-titlebar-green",
    lemon: "xp-titlebar-lemon",
    red: "xp-titlebar-red",
  }[variant] || "xp-titlebar-blue";

  return (
    <div
      data-testid={testId}
      className={`bevel-out bg-[#ECE9D8] flex flex-col min-h-0 ${className}`}
    >
      <div className={`${bar} h-[24px] flex items-center justify-between px-2 select-none`}>
        <div className="flex items-center gap-1.5 text-[12.5px] font-bold tracking-wide">
          {Icon && <Icon size={13} />}
          {title}
        </div>
        {actions && <div className="flex items-center gap-1">{actions}</div>}
      </div>
      <div className={`p-2 flex-1 min-h-0 ${contentClassName}`}>
        {children}
      </div>
    </div>
  );
}
